import { Controller } from '@hotwired/stimulus'

// Drives a "select all" checkbox that also supports an indeterminate state,
// demonstrating the new checkbox component wired up with Stimulus.
export default class extends Controller {
  static targets = ['all', 'item']

  connect() {
    this.refresh()
  }

  toggleAll() {
    this.itemTargets.forEach((item) => {
      item.checked = this.allTarget.checked
    })
    this.refresh()
  }

  refresh() {
    const total = this.itemTargets.length
    const checkedCount = this.itemTargets.filter((item) => item.checked).length

    this.allTarget.checked = total > 0 && checkedCount === total
    this.allTarget.indeterminate = checkedCount > 0 && checkedCount < total
  }
}
